import Mail from '../components/Mail';

(function () {
  const contactforms = document.querySelectorAll('[data-contactform]');

  Array.from(contactforms).forEach(contactForm => {
    contactForm.querySelector('form').addEventListener('submit', async (e) => {
      e.preventDefault();

      contactForm.querySelector('.contact__error-msg').innerText = '';

      const get = getValue(contactForm);

      let apartmentType = get('input[name="apartmenttype"]:checked');
      const formType = contactForm.getAttribute('data-formtype');
      const formLayout = contactForm.getAttribute('data-form-layout');

      if (formType.toLowerCase() !== 'rental and sale') {
        apartmentType = formType;
      }

      sendMail({
        culture: window.oxygen ? window.oxygen.culture : null,
        name: get('input[name^="name"]'),
        phone: get('input[name^="phone"]'),
        email: get('input[name^="email"]'),
        message: get('textarea[name^="message"]'),
        formType: formType,
        apartmentType: apartmentType,
        acceptTerms: get('input[name="acceptterms"]:checked'),
        subject: contactForm.getAttribute('data-subject'),
        formLayout: formLayout,
      }, contactForm);
    });
  });

  async function sendMail(data, contactForm) {
    const mail = new Mail(data);
    const response = await mail.send();

    if (response.status !== 200) {
      contactForm.querySelector('.contact__error-msg').innerText = response.json.message;
      return;
    }

    contactForm.classList.add('contact--success')
  }

  function getValue(contactForm) {
    return (selector) => {
      const elm = contactForm.querySelector(selector);
      return elm ? elm.value : '';
    }
  }
})();
